import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "core-js/modules/es.string.link.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { generatePath, Link, useLocation } from 'react-router-dom';
import createLocation from 'utils/createLocation';
import EditorPageHeader, { StickyEditorPageHeaderWrapper } from 'components/EditorPageHeader';
import FixedHeightTab from 'components/Tab/FixedHeightTab';
import Icon from 'components/Icon';
import PageBackLink from 'components/PageBackLink';
import { sessionQueryParameters } from './utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function SessionHeader(_ref) {
  var isNested = _ref.isNested,
    session = _ref.session,
    tabLinks = _ref.tabLinks;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var location = useLocation();
  var backTo = createLocation(location, _defineProperty(_defineProperty({}, sessionQueryParameters.id, undefined), sessionQueryParameters.tab, undefined));
  var sessionId = String(session.id);
  return /*#__PURE__*/_jsx(StickyEditorPageHeaderWrapper, {
    children: /*#__PURE__*/_jsxs(EditorPageHeader, {
      preTitleContent: /*#__PURE__*/_jsx(PageBackLink, {
        mb: "xs",
        to: backTo,
        children: t('actions_back_to_sessions_list')
      }),
      title: session.startDate,
      cardVariant: "raised",
      headingLevel: isNested ? 'h2' : 'h1',
      children: [/*#__PURE__*/_jsxs(FixedHeightTab, {
        isActive: tabLinks.details.isActive,
        as: Link,
        to: generatePath(tabLinks.details.link, {
          sessionId: sessionId
        }),
        "aria-current": tabLinks.details.isActive ? 'page' : undefined,
        children: [/*#__PURE__*/_jsx(Icon, {
          name: "calendar",
          mr: "xs"
        }), t('panel_tab_details')]
      }), /*#__PURE__*/_jsxs(FixedHeightTab, {
        isActive: tabLinks.attendees.isActive,
        as: Link,
        to: generatePath(tabLinks.attendees.link, {
          sessionId: sessionId
        }),
        "aria-current": tabLinks.attendees.isActive ? 'page' : undefined,
        children: [/*#__PURE__*/_jsx(Icon, {
          name: "team",
          mr: "xs"
        }), t('panel_tab_attendees')]
      })]
    })
  });
}
export default SessionHeader;